import AccessoryCommon from "./accessoryCommon";
import {Shower} from "../../parts/shower";
import {
  shouldUseSafetyPackage,
  updateFeatureGroupsWithNewSide
} from "../../../../bvSceneComponent/core/safetyPackageSidesLogic";

export default class LShapedGrabBar extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'l_shaped_grab_bar';
    this.partName = 'L Shaped Grab Bar';
    this.translateId = "visualizer.bathroom.accessories.l_shaped_grab_bar";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      this.oneLayerPosition = true;
    }
  }

  disabledClick() {
    super.disabledClick();
    if (!this.disabled && this.activeFeature) {
      if (shouldUseSafetyPackage(this) && this.activeFeature.metaData["layerPosition"]) {
        updateFeatureGroupsWithNewSide(this.activeFeature, this.activeFeature.metaData["layerPosition"]);
      }
    }
  }

  navigationSubItems(filters, searchText) {
    return this.navigationSubItemsWithSides(filters, searchText);
  }

  setLayers(layout) {
    const showerParent = this.getParent().layout.parts[Shower.id];
    if (showerParent && showerParent.showerTubComboIsActive()) { //  shower tub combo - remove
      super.hideLayers();
      return;
    }

    return super.setLayers(layout);
  }

}
